import Vue from 'vue'
import { mapState } from 'vuex'

import ImageLink from '@/components/image-link/image-link.vue'
import PlanList from './components/plan_list.vue'

import { getContent } from '@/api/content'

export default Vue.extend({
  name: 'BuyPlan',
  components: {
    PlanList,
    ImageLink
  },
  data() {
    return {
      content: undefined,
      paymentOption: '',
      selectedPlanId: null
    }
  },
  created() {
    this.fetchData()
    const currentDate = new Date()
    const id = this.$route.params.id
    const contracts = this.user.contracts
    for (let index = 0; index < contracts.length; index++) {
      const contract = contracts[index];
      if(contract.content_id === id) {
        const isExpired = new Date(contract.expire_at)
        if (currentDate <= isExpired) {
            this.$router.push({ path: `/` })
        }
      }
    }
  },
  computed: {
    ...mapState(['loading', 'user'])
  },
  methods: {
    async fetchData() {
      this.$store.dispatch('loading')
      const res = await getContent(+this.$route.params.id).catch((err) => {
        if (err.response && err.response.status === 404) {
          this.$router.push({ path: `/contents/${this.$route.params.id}` })
          return
        }
        throw err
      })

      if (!res) {
        return
      }

      this.content = res.data
      if (this.content.limit_purchase_message) {
        this.$router.push({ path: '/' })
        return
      }
      this.$store.dispatch('setTitle', this.content.title)
      this.$store.dispatch('loading', false)
    },
    choose({id}) {
      this.selectedPlanId = this.selectedPlanId === id ? null : id
    },
    pay() {
      this.$router.push({ path: `/contents/${this.$route.params.id}/buy_plan/${this.selectedPlanId}` })
    }
  },
})
